// Modules
export const MODULE_PROPS = {
  hook: "hook",
  on: "on",
  attrs: "attrs",
  props: "props",
  style: "style",
  class: "class",
  dataset: "dataset",
}

// Props that move to `props` module
export const PROP_ALIAS_MAP = {
  className: "className",
  "class-name": "className",
  "tab-index": "tabIndex",
  tabIndex: "tabIndex",
  id: "id",
}

export const ATTR = "attr"
export const PROP = "prop"
export const DATA = "data"
export const KEY = "key"
export const HYPHEN_CHAR = "-"
